module.exports = __webpack_public_path__ + "assets/img/services7.9e3f0ac7.svg";